module.exports = __webpack_public_path__ + "media/Icelandic_Arpeggios.b8dd09db.mp3";